import { render, staticRenderFns } from "./Mini_Category.vue?vue&type=template&id=2e5276bc&scoped=true&"
import script from "./Mini_Category.vue?vue&type=script&lang=js&"
export * from "./Mini_Category.vue?vue&type=script&lang=js&"
import style0 from "./Mini_Category.vue?vue&type=style&index=0&id=2e5276bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5276bc",
  null
  
)

export default component.exports